import React, { Fragment } from 'react'
import { connect } from 'react-redux'

import { makeStyles } from '@material-ui/styles'
import { themeConWeb } from '../../util/modernThemeConweb'
import ActiveOrderStatus from './ActiveOrderStatus'

const useStyles = makeStyles({
  orderHr: {
    borderColor: themeConWeb.color.brandSecondary,
    backgroundColor: themeConWeb.color.brandSecondary,
    opacity: 0.1,
  },
})

const OrderStatus = props => {
  const classes = useStyles()

  const { orders = [], loading, locationId } = props

  const sortedFilteredOrders = orders
    .sort((a, b) => new Date(a.orderDateTime).getTime() - new Date(b.orderDateTime).getTime())
    .filter(order => {
      return order.orderState === 'CANCELED' &&
        orders.find(
          o => o.orderState !== 'CANCELED' && o.deliveryDropoffId === order.deliveryDropoffId,
        )
        ? false
        : true
    })

  return sortedFilteredOrders.map((order, index) => {
    return (
      <Fragment key={index}>
        <ActiveOrderStatus
          loading={loading}
          locationId={locationId}
          order={order}
          statusText={order.statusText}
        />
        {sortedFilteredOrders.length > 1 &&
          index !== sortedFilteredOrders.length - 1 &&
          !loading && <hr className={classes.orderHr} />}
      </Fragment>
    )
  })
}

const mapStateToProps = state => {
  const { loading, orders } = state.orderDetail
  return {
    loading,
    orders,
  }
}

export default connect(mapStateToProps)(OrderStatus)
